import React from 'react';
import { I18n } from 'react-redux-i18n';
import CapacityDisplay from './CapacityDisplay';

const AffiliateCarCard = ({ car }) => (
  <div className="affiliate-car-card">
    <div className="car-card-header">{I18n.t('networkSetting.AffiliateCarType')}</div>
    <div className="car-card-content">
      <div className="car-icon-name-row">
        <img src={car.icon} alt={car.label} className="car-icon" />
        <div className="car-info">
          <div className="car-name">{car.label}</div>
          <CapacityDisplay passengers={car.passengers} luggage={car.luggage} />
        </div>
      </div>
    </div>
  </div>
);

export default AffiliateCarCard;